<template>
  <v-item-group v-model="selected" active-class="primary">
    <v-container>
      <v-row>
        <v-col v-for="item in items" :key="item.label" cols="12" sm="6" md="4">
          <v-item v-slot:default="{ active, toggle }">
            <v-card dark @click="toggle" :class="active? 'shadow':null ">
              <v-img
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                :src="item.src"
                height="200"
                class="text-center align-end pa-2"
              >
                <v-scroll-y-transition>
                  <div v-if="active" class="display-1 flex-grow-1 text-center white--text">
                    <v-icon x-large>mdi-check</v-icon>
                  </div>
                </v-scroll-y-transition>
                <v-card-title class="pb-0" v-text="item.label"></v-card-title>
              </v-img>
            </v-card>
          </v-item>
        </v-col>
      </v-row>
    </v-container>
  </v-item-group>
</template>

<script>
export default {
  data() {
    return {
      selected: {},
      items: [
        {
          label: "Perdre du poids",
          src: require("@/assets/images/losing-weight.jpg")
        },
        {
          label: "Renforcement musculaire",
          src: require("@/assets/images/muscles.jpg")
        },
        {
          label: "Remise en forme",
          src: require("@/assets/images/casual-body.jpg")
        }
      ]
    };
  },
  watch: {
    selected(value) {
      if (value !== undefined) this.$emit("onSelected", value);
    }
  },
  methods: {
    updateValue: value => {
      // console.log("log", value);
      if (value !== undefined) this.$emit("change", value);
    }
  }
};
</script>

<style scoped>
.shadow {
  box-shadow: 2px 5px 10px #d44a4a;
}
</style>